import { c as _c } from "react/compiler-runtime";
interface NowMintingStatsItemProps {
  readonly label: string;
  readonly value?: string | undefined;
  readonly status?: "active" | "upcoming" | "ended" | undefined;
  readonly isLoading?: boolean;
}
export default function NowMintingStatsItem(t0) {
  const $ = _c(11);
  const {
    label,
    value,
    status,
    isLoading
  } = t0;
  let t1;
  if ($[0] !== status) {
    t1 = () => {
      if (status === "active") {
        return "tw-text-emerald-400";
      }
      if (status === "ended") {
        return "tw-text-iron-400";
      }
      return "tw-text-iron-100";
    };
    $[0] = status;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getValueColor = t1;
  let t2;
  if ($[2] !== label) {
    t2 = <span className="tw-text-xs tw-font-medium tw-text-iron-400">{label}</span>;
    $[2] = label;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== getValueColor || $[5] !== isLoading || $[6] !== value) {
    t3 = isLoading ? <span className="tw-h-6 tw-w-20 tw-animate-pulse tw-rounded tw-bg-iron-800" /> : <span className={`tw-whitespace-nowrap tw-font-mono tw-text-sm tw-font-medium md:tw-text-base ${getValueColor()}`}>{value}</span>;
    $[4] = getValueColor;
    $[5] = isLoading;
    $[6] = value;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className="tw-flex tw-flex-col tw-gap-1">{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}